"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _recompose = require("recompose");
var _classnames = _interopRequireDefault(require("classnames"));
var _keycode = _interopRequireDefault(require("keycode"));
var _reactColor = require("react-color");
var _colors = _interopRequireWildcard(require("../../style/colors"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _InputRequired = _interopRequireDefault(require("../InputRequired/InputRequired"));
var _ModalView = require("../../View/ModalView/ModalView");
var _excluded = ["classes", "className", "color", "colors", "defaultValue", "disabled", "displayErrors", "hasError", "hasRequired", "hasSuccess", "hasValidation", "inputClassName", "inputRef", "modalViewContext", "name", "onBlur", "onChange", "readOnly", "required", "setDisplayErrorsState", "setLoadingState", "theme", "title"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type ElementRef } from 'react';*/ /*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: {
      position: 'relative'
    },
    input: _objectSpread(_objectSpread(_objectSpread({}, theme.mixins.inputStyle), theme.mixins.truncate), {}, {
      paddingLeft: '2.5rem',
      textTransform: 'uppercase',
      '&:required:invalid': {
        paddingRight: theme.variables.inputRequiredPaddingRight
      },
      '&:focus:required:invalid, &:required:valid': _objectSpread(_objectSpread({}, theme.mixins.inputPadding), {}, {
        '& ~ $required': {
          display: 'none'
        }
      }),
      '&[readonly]': {
        '&, &:focus, &:hover': theme.mixins.inputReadOnly
      }
    }),
    displayErrors: {
      '&:valid': theme.mixins.inputSuccess,
      '&:invalid': theme.mixins.inputError
    },
    success: theme.mixins.inputSuccess,
    error: theme.mixins.inputError,
    required: {},
    readOnly: {
      '&[readonly]': {
        '&, &:focus, &:hover': theme.mixins.inputReadOnly
      }
    },
    disabled: {
      '&:disabled': {
        '&, &:focus, &:hover': theme.mixins.inputDisabled
      }
    },
    color: _objectSpread(_objectSpread({}, theme.mixins.verticalAlign), {}, {
      position: 'absolute',
      left: '.813rem',
      width: '1rem',
      height: '1rem',
      pointerEvents: 'none'
    }),
    popover: {
      position: 'absolute',
      zIndex: function zIndex(_ref) {
        var modalViewContext = _ref.modalViewContext;
        return "".concat(modalViewContext ? theme.zIndex.modal : theme.zIndex.menu);
      }
    },
    cover: {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  };
};
/*:: export type ColorInputType = InjectSheetProvidedProps &
  HTMLInputElement & {
    color: string,
    colors: Array<string>,
    displayErrors: boolean,
    hasError: boolean,
    hasRequired: boolean,
    hasSuccess: boolean,
    hasValidation?: boolean,
    inputClassName?: string,
    inputRef?: ElementRef<*>,
    modalViewContext: boolean,
    onBlur?: ({
      currentTarget: { id: string, name: string, value: string }
    }) => mixed,
    onChange?: ({
      currentTarget: { id: string, name: string, value: string }
    }) => mixed,
    open: boolean,
    setDisplayErrorsState?: (displayErrors: boolean) => mixed,
    setLoadingState?: (loading: boolean) => mixed
  };*/
/*:: type State = {
  color: string,
  open: boolean
};*/
var ColorInput = /*#__PURE__*/function (_PureComponent) {
  function ColorInput() {
    var _this;
    (0, _classCallCheck2.default)(this, ColorInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ColorInput, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      color: _this.props.color,
      open: _this.props.open
    });
    (0, _defineProperty2.default)(_this, "handleChangeComplete", function (_ref2) {
      var hex = _ref2.hex;
      var _this$props = _this.props,
        id = _this$props.id,
        name = _this$props.name,
        onChange = _this$props.onChange;
      _this.setState({
        color: hex
      });
      if (onChange) {
        return onChange({
          currentTarget: {
            id: id,
            name: name,
            value: hex
          }
        });
      }
    });
    (0, _defineProperty2.default)(_this, "handleFocus", function (event /*: SyntheticEvent<HTMLInputElement>*/) {
      event.preventDefault();
      return _this.setState({
        open: true
      });
    });
    (0, _defineProperty2.default)(_this, "handleClose", function (event /*: SyntheticEvent<HTMLInputElement>*/) {
      event.preventDefault();
      var _this$props2 = _this.props,
        id = _this$props2.id,
        name = _this$props2.name,
        onBlur = _this$props2.onBlur;
      var color = _this.state.color;
      _this.setState({
        open: false
      });
      if (onBlur) {
        return onBlur({
          currentTarget: {
            id: id,
            name: name,
            value: color
          }
        });
      }
    });
    return _this;
  }
  (0, _inherits2.default)(ColorInput, _PureComponent);
  return (0, _createClass2.default)(ColorInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        classes = _this$props3.classes,
        className = _this$props3.className,
        colorProp = _this$props3.color,
        colors = _this$props3.colors,
        defaultValue = _this$props3.defaultValue,
        disabled = _this$props3.disabled,
        displayErrors = _this$props3.displayErrors,
        hasError = _this$props3.hasError,
        hasRequired = _this$props3.hasRequired,
        hasSuccess = _this$props3.hasSuccess,
        hasValidation = _this$props3.hasValidation,
        inputClassName = _this$props3.inputClassName,
        ref = _this$props3.inputRef,
        modalViewContext = _this$props3.modalViewContext,
        name = _this$props3.name,
        onBlur = _this$props3.onBlur,
        onChange = _this$props3.onChange,
        readOnly = _this$props3.readOnly,
        required = _this$props3.required,
        setDisplayErrorsState = _this$props3.setDisplayErrorsState,
        setLoadingState = _this$props3.setLoadingState,
        theme = _this$props3.theme,
        title = _this$props3.title,
        props = (0, _objectWithoutProperties2.default)(_this$props3, _excluded);
      var _this$state = this.state,
        color = _this$state.color,
        open = _this$state.open;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.root, className),
        title: title
      }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
        className: (0, _classnames.default)(classes.input, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.displayErrors, displayErrors), classes.error, hasError), classes.success, hasSuccess), classes.disabled, disabled), classes.readOnly, readOnly), inputClassName),
        "data-name": name,
        disabled: disabled || readOnly,
        onFocus: this.handleFocus,
        onKeyDown: function onKeyDown(event) {
          if ((0, _keycode.default)(event) === 'esc') {
            return _this2.handleClose(event);
          }
        },
        readOnly: true,
        value: color
      }, _objectSpread({
        name: name,
        ref: ref,
        required: required
      }, props))), /*#__PURE__*/_react.default.createElement(_InputRequired.default, {
        className: classes.required,
        disabled: disabled,
        hasRequired: hasRequired,
        readOnly: readOnly,
        required: required
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: classes.color,
        style: {
          backgroundColor: color
        }
      }), open && /*#__PURE__*/_react.default.createElement("div", {
        className: classes.popover
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.cover,
        onClick: this.handleClose,
        onKeyDown: function onKeyDown(event) {
          if ((0, _keycode.default)(event) === 'esc') {
            return _this2.handleClose(event);
          }
        },
        role: "button",
        tabIndex: -1
      }), /*#__PURE__*/_react.default.createElement(_reactColor.TwitterPicker, {
        onChangeComplete: this.handleChangeComplete,
        color: color,
        colors: colors
      })));
    }
  }]);
}(_react.PureComponent);
(0, _defineProperty2.default)(ColorInput, "displayName", 'ColorInput');
(0, _defineProperty2.default)(ColorInput, "defaultProps", {
  autoComplete: 'off',
  color: _colors.default.black,
  colors: Object.values(_colors.COLORS),
  displayErrors: false,
  hasError: false,
  hasRequired: true,
  hasSuccess: false,
  open: false,
  type: 'text'
});
var _default = exports.default = (0, _recompose.compose)(_ModalView.withModalViewContext, (0, _injectSheet.default)(Style))(ColorInput);
//# sourceMappingURL=ColorInput.js.map